import { atom } from "recoil";

import { persistAtom } from "./persist";

// The resolved variant the user sees, whatever assigned it.
export const NewNavOptInState = atom<boolean>({
  key: "NewNavOptIn_v1",
  default: false,
  effects_UNSTABLE: [persistAtom],
});

// Set when someone who opted out asks for the new nav back. The server keeps
// its opt-out record for analysis, so this only governs what they see.
export const NavOptedBackInState = atom<boolean>({
  key: "NavOptedBackIn_v1",
  default: false,
  effects_UNSTABLE: [persistAtom],
});

// Separate from the variant so analysis can drop these users from both arms.
export const NavOptOutState = atom<boolean>({
  key: "NavOptOut_v1",
  default: false,
  effects_UNSTABLE: [persistAtom],
});

// Which _id the stored variant belongs to, so a second account on a shared
// browser is rebucketed.
export const NavBucketedIdState = atom<string | null>({
  key: "NavBucketedId_v1",
  default: null,
  effects_UNSTABLE: [persistAtom],
});
